import {
  FETCH_SONG_MODELS_REQUEST,
  FETCH_SONG_MODELS_SUCCESS,
  FETCH_SONG_MODELS_FAILURE,
  ADD_SONG_MODEL_REQUEST,
  ADD_SONG_MODEL_SUCCESS,
  ADD_SONG_MODEL_FAILURE,
  UPDATE_SONG_MODEL_REQUEST,
  UPDATE_SONG_MODEL_SUCCESS,
  UPDATE_SONG_MODEL_FAILURE,
  DELETE_SONG_MODEL_REQUEST,
  DELETE_SONG_MODEL_SUCCESS,
  DELETE_SONG_MODEL_FAILURE
} from '../types/authTypes';
import axiosInstance from '../../utils/setupAxios';

// Fetch SongModels
export const fetchSongModelsRequest = () => ({
  type: FETCH_SONG_MODELS_REQUEST
});

export const fetchSongModelsSuccess = (data) => ({
  type: FETCH_SONG_MODELS_SUCCESS,
  payload: data
});

export const fetchSongModelsFailure = (error) => ({
  type: FETCH_SONG_MODELS_FAILURE,
  payload: error
});

export const fetchSongModels = (page = 1, itemsPerPage = 10, filters = {}) => {
  return async (dispatch) => {
    dispatch(fetchSongModelsRequest());

    const params = {
      page,
      items_per_page: itemsPerPage
    };

    // Add filter parameters if they exist
    if (filters.type === 'category_code') {
      params.category_code = filters.category_id;
    } else if (filters.type === 'sub_category_code') {
      params.sub_category_code = filters.category_id;
    }

    if (filters.language) {
      params.language = filters.language;
    }

    if (filters.search) {
      params.search = filters.search;
    }

    if (filters.sort_by_field) {
      params.sort_by_field = filters.sort_by_field;
    }

    if (filters.sort_direction) {
      params.sort_direction = filters.sort_direction;
    }

    if (filters.is_backup) {
      params.is_backup = filters.is_backup;
    }

    try {
      const response = await axiosInstance.get(`/songs/models`, { params });
      if (response.data.success) {
        dispatch(fetchSongModelsSuccess(response.data.data));
        return response.data;
      } else {
        dispatch(fetchSongModelsFailure(response.data.message || 'Failed to fetch song-models'));
        return response.data;
      }
    } catch (error) {
      dispatch(fetchSongModelsFailure(error.response?.data?.message || 'Failed to fetch song-models'));
      throw error;
    }
  };
};

// Add Song Models
export const addSongModelsRequest = () => ({
  type: ADD_SONG_MODEL_REQUEST
});

export const addSongModelsSuccess = (songModel) => ({
  type: ADD_SONG_MODEL_SUCCESS,
  payload: songModel
});

export const addSongModelsFailure = (error) => ({
  type: ADD_SONG_MODEL_FAILURE,
  payload: error
});

export const addSongModels = (songModelData) => {
  return async (dispatch) => {
    dispatch(addSongModelsRequest());
    try {
      const response = await axiosInstance.post('/songs/models', songModelData);
      if (response.data.success) {
        dispatch(addSongModelsSuccess(response.data.data));
        return response.data;
      } else {
        dispatch(addSongModelsFailure(response.data.message || 'Failed to add song model'));
        return response.data;
      }
    } catch (error) {
      dispatch(addSongModelsFailure(error.response?.data?.message || 'Failed to add song model'));
      throw error;
    }
  };
};

// Update SongModels
export const updateSongModelsRequest = () => ({
  type: UPDATE_SONG_MODEL_REQUEST
});

export const updateSongModelsSuccess = (songModel) => ({
  type: UPDATE_SONG_MODEL_SUCCESS,
  payload: songModel
});

export const updateSongModelsFailure = (error) => ({
  type: UPDATE_SONG_MODEL_FAILURE,
  payload: error
});

export const updateSongModels = (songModelData) => {
  return async (dispatch) => {
    dispatch(updateSongModelsRequest());
    try {
      const response = await axiosInstance.post(`/songs/models/update`, songModelData);
      if (response.data.success) {
        dispatch(updateSongModelsSuccess(response.data.data));
        return response.data;
      } else {
        dispatch(updateSongModelsFailure(response.data.message || 'Failed to update song model'));
        return response.data;
      }
    } catch (error) {
      dispatch(updateSongModelsFailure(error.response?.data?.message || 'Failed to update song model'));
      throw error;
    }
  };
};

// Delete SongModels
export const deleteSongModelsRequest = () => ({
  type: DELETE_SONG_MODEL_REQUEST
});

export const deleteSongModelsSuccess = (id) => ({
  type: DELETE_SONG_MODEL_SUCCESS,
  payload: id
});

export const deleteSongModelsFailure = (error) => ({
  type: DELETE_SONG_MODEL_FAILURE,
  payload: error
});

export const deleteSongModels = (id) => {
  return async (dispatch) => {
    dispatch(deleteSongModelsRequest());
    try {
      const data = {id: id};
      const response = await axiosInstance.post(`/songs/models/delete`, data);
      if (response.data.success) {
        dispatch(deleteSongModelsSuccess(id));
        return response.data;
      } else {
        dispatch(deleteSongModelsFailure(response.data.message || 'Failed to delete song model'));
        return response.data;
      }
    } catch (error) {
      dispatch(deleteSongModelsFailure(error.response?.data?.message || 'Failed to delete song model'));
      throw error;
    }
  };
}; 